import { render } from "./EmployeeApprovalsEditApprovals.vue?vue&type=template&id=6082bce7"
import script from "./EmployeeApprovalsEditApprovals.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsEditApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__